// Утилиты для форматирования дат без зависимости от часового пояса браузера.
// Работают с датами в формате 'YYYY-MM-DD' или ISO-строками вида 'YYYY-MM-DDTHH:mm:ssZ'.

const MONTHS_RU_GENITIVE = [
    'января',
    'февраля',
    'марта',
    'апреля',
    'мая',
    'июня',
    'июля',
    'августа',
    'сентября',
    'октября',
    'ноября',
    'декабря'
];

export const extractYmd = (value) => {
    if (!value) return null;
    const s = String(value).trim();
    const match = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return null;
    const year = parseInt(match[1], 10);
    const month = parseInt(match[2], 10);
    const day = parseInt(match[3], 10);
    if (!year || !month || !day) return null;
    return { year, month, day };
};

// Короткий формат: 08.03.2026
export const formatDateShortRu = (value) => {
    const ymd = extractYmd(value);
    if (!ymd) return '';
    const { year, month, day } = ymd;
    const dd = String(day).padStart(2, '0');
    const mm = String(month).padStart(2, '0');
    return `${dd}.${mm}.${year}`;
};

// Длинный формат: 8 марта 2026
export const formatDateLongRu = (value) => {
    const ymd = extractYmd(value);
    if (!ymd) return '';
    const { year, month, day } = ymd;
    const monthName = MONTHS_RU_GENITIVE[month - 1] || '';
    return `${day} ${monthName} ${year}`;
};

// Диапазон дат: 
// - если один день: 8 марта 2026
// - если один месяц и год: 12–14 марта 2026
// - если разные месяцы/годы: 28 февраля 2026 – 2 марта 2026
export const formatDateRangeRu = (startValue, endValue) => {
    const start = extractYmd(startValue);
    const end = extractYmd(endValue);
    if (!start || !end) return '';

    if (start.year === end.year && start.month === end.month && start.day === end.day) {
        return formatDateLongRu(startValue);
    }

    if (start.year === end.year && start.month === end.month) {
        const monthName = MONTHS_RU_GENITIVE[start.month - 1] || '';
        return `${start.day}–${end.day} ${monthName} ${start.year}`;
    }

    return `${formatDateLongRu(startValue)} – ${formatDateLongRu(endValue)}`;
};

